import React, { useEffect, useMemo, useState } from "react";
import { MaterialReactTable } from "material-react-table";
import { Button, Stack, TextField } from "@mui/material";
import { Search } from "@mui/icons-material";
import axios from "axios";
import Swal from "sweetalert2";
import { CircularProgress, Backdrop } from "@mui/material";

const InfoContreebute = () => {
  const postData = (e) => {
    window.location.href = "/#/CrearContreebute";
  };

  const [añoConsulta, setAñoConsulta] = useState(new Date().getFullYear());
  const [list1, setList1] = useState([]);
  const [tableData, setTableData] = useState([]);

  const [loading, setLoading] = useState(false);

  const consultarPorAño = () => {
    setLoading(true); // Mostrar loading
    const url = `https://middlewarebackprd.azurewebsites.net/api/v1/VerContreebute/${añoConsulta}`;
    axios({
      auth: {
        username: "admin.icontec@icontec.org",
        password: "quAngEraMuSTerGerEDE",
      },
      headers: {
        "Access-Control-Allow-Origin": "*",
      },
      method: "get",
      url: url,
    })
      .then((response) => {
        setList1(response.data);
        setTableData(response.data);
      })
      .catch((error) => {
        console.log(error);
        Swal.fire("Error", "No se pudo obtener la información", "error");
      })
      .finally(() => {
        setLoading(false); // Ocultar loading
      });
  };

  useEffect(() => {
    consultarPorAño();
  }, []);

  const columns = useMemo(
    () => [
      { accessorKey: "RazonSocial", header: "Razon Social", size: 80 },
      { accessorKey: "NIT", header: "NIT", size: 80 },
      {
        accessorKey: "DireccionSedePrincipal",
        header: "Dirección Sede Principal",
        size: 80,
      },
      { accessorKey: "Ciudad", header: "Ciudad", size: 80 },
      { accessorKey: "Pais", header: "Pais", size: 80 },
      { accessorKey: "CorreoEmpresa", header: "Correo Empresa", size: 80 },
      { accessorKey: "TipoEvaluacion", header: "Tipo Evaluacion", size: 80 },
      {
        accessorKey: "DireccionamientoEstrategico",
        header: "DireccionamientoEstrategico",
        size: 80,
      },
      {
        accessorKey: "DimensionAmbiental",
        header: "DimensionAmbiental",
        size: 80,
      },
      {
        accessorKey: "DimensionEconomica",
        header: "DimensionEconomica",
        size: 80,
      },
      { accessorKey: "DimensionSocial", header: "DimensionSocial", size: 80 },
      { accessorKey: "ResultadoTotal", header: "ResultadoTotal", size: 80 },
      {
        accessorKey: "CategoriaAlcanzada",
        header: "CategoriaAlcanzada",
        size: 80,
      },
      {
        accessorKey: "NumeroCertificado",
        header: "NumeroCertificado",
        size: 80,
      },
      { accessorKey: "NombreAuditor", header: "NombreAuditor", size: 80 },
      {
        accessorKey: "FechaOtorgamiento",
        header: "FechaOtorgamiento",
        size: 80,
      },
      { accessorKey: "FechaVencimiento", header: "FechaVencimiento", size: 80 },
      { accessorKey: "FechaAprobacion", header: "FechaAprobacion", size: 80 },
      {
        accessorKey: "FechaActualizacion",
        header: "FechaActualizacion",
        size: 80,
      },
      {
        accessorKey: "NombreImagenSello",
        header: "NombreImagenSello",
        size: 80,
      },
      { accessorKey: "URLImagenSello", header: "URLImagenSello", size: 80 },
    ],
    [],
  );
  const sincronizarPorAño = () => {
    Swal.fire({
      title: "¿Sincronizar información?",
      text: `Se sincronizará la información del año ${añoConsulta}`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Sí, sincronizar",
      cancelButtonText: "Cancelar",
    }).then((result) => {
      if (result.isConfirmed) {
        setLoading(true);

        const url = `https://middlewarebackprd.azurewebsites.net/api/v1/SincronizaContreebute/${añoConsulta}`;

        axios({
          auth: {
            username: "admin.icontec@icontec.org",
            password: "quAngEraMuSTerGerEDE",
          },
          method: "get", // normalmente estas APIs son POST
          url: url,
        })
          .then(() => {
            Swal.fire(
              "Sincronizado",
              "La información se sincronizó correctamente",
              "success",
            );
            consultarPorAño(); // refresca la tabla después de sincronizar
          })
          .catch((error) => {
            console.error(error);
            Swal.fire(
              "Error",
              "No se pudo sincronizar la información",
              "error",
            );
          })
          .finally(() => {
            setLoading(false);
          });
      }
    });
  };

  return (
    <div>
      <Stack direction="row" spacing={2} alignItems="center" sx={{ mb: 2 }}>
        <TextField
          label="Año"
          type="number"
          value={añoConsulta}
          onChange={(e) => setAñoConsulta(e.target.value)}
          inputProps={{ min: 2000, max: 2100 }}
          onKeyDown={(e) => {
            if (e.key === "Enter") consultarPorAño();
          }}
        />

        <Button
          variant="contained"
          color="primary"
          startIcon={<Search />}
          onClick={consultarPorAño}
        >
          Consultar
        </Button>

        <Button
          variant="contained"
          color="secondary"
          onClick={sincronizarPorAño}
        >
          Sincronizar
        </Button>

        <Button
          className="btn btn-primary"
          variant="contained"
          onClick={postData}
        >
          Crear Contreebute
        </Button>
      </Stack>

      <MaterialReactTable
        displayColumnDefOptions={{
          "mrt-row-actions": {
            muiTableHeadCellProps: { align: "center" },
            size: 120,
          },
        }}
        columns={columns}
        data={list1}
        editingMode="modal"
        enableColumnOrdering
      />
      <Backdrop open={loading} style={{ zIndex: 9999, color: "#fff" }}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </div>
  );
};

export default InfoContreebute;
